import Vue from 'vue';
import ApplyListHeader from './components/ApplyListHeader.vue';
import ApplyList from './components/ApplyList.vue';

new Vue({
	el: "#daumContent",
	render: h => h(ApplyList)
});

new Vue({
	el: "#cafe_navi_default",
	render: h => h(ApplyListHeader)
});
